<template>
  <div class="container" id="app">
    <router-view></router-view>
    <footer class="top-footer">
      <div class="foot-box"> 
        <div class="finfo">
          <p class="fname"><span>東北大学災害科学国際研究所</span><span>災害アーカイブ研究分野</span></p>
          <div class="flogo-box">
            <ul>
              <li><a href="http://irides.tohoku.ac.jp" target="_blank"><img src="./assets/flogo.png" alt="東北大学災害科学国際研究所" class="img-responsive"></a></li>
              <li><a href="http://www.shinrokuden.irides.tohoku.ac.jp/" target="_blank"><img src="./assets/srdn.png" alt="" class="img-responsive"></a></li></ul>
          </div>
        </div>

        <div class="toh"><a href="https://www.tohoku.ac.jp/" target="_blank"><img src="./assets/toh.png" alt="東北大学"></a></div>
      </div>
      <div class="foot-cbox">
        <div class="copy-box">
          <div class="term"><a href="usepolicy_ja.pdf" target="_blank">ご利用規約</a></div>
          <div class="copyright"><span>Copyright（C）2019. 災害科学国際研究所. </span><span>All Rights Reserved.</span></div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
 import Vue from 'vue'
 import Vuex from 'vuex'
 import createPersistedState from 'vuex-persistedstate';
 import Vuetify from 'vuetify'
 import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
 import VueRouter from 'vue-router'
 import VeeValidate from 'vee-validate';
 import ja from 'vee-validate/dist/locale/ja';

 import VueLayers from 'vuelayers'
 import 'vuelayers/lib/style.css' // needs css-loader



 import Top from './components/Top.vue'
 import Result from './components/Result.vue'
 import ResultLine from './components/ResultLine.vue'
 import ResultTile from './components/ResultTile.vue'
 import ResultMap from './components/ResultMap.vue'
 import ResultCompare from './components/ResultCompare.vue'
 import Detail from './components/Detail.vue'
 import { RepositoryFactory } from './repositories/RepositoryFactory'
 import { point_resource } from './repositories/itemsRepository'

 import { Map, TileLayer, XyzSource} from 'vuelayers'


 const ItemsRepository = RepositoryFactory.get('items')

 const format = require('date-fns/format');

 

 
 Vue.use(VueRouter);
 Vue.use(Vuetify)
 Vue.use(Vuex)
 VeeValidate. Validator.localize('ja', ja);
 Vue.use(VeeValidate, { locale: ja });

 Vue.use(VueLayers, {
     dataProjection: 'EPSG:4326',
 })
 Vue.use(Map)
 Vue.use(TileLayer)
 Vue.use(XyzSource)

 Vue.filter('dateFormatter',function (date) {
     return format(date, 'YYYY/MM/DD HH:mm:SS')
 })

 const initialState = {
     data: [],
     mapdata: [],
     neardata: [],
     recent: [],
     recentId:[],
     comparedata: [],
     recentMode : false,
     facetCondition: {
         from:'',
         until:''
     },

 }
 const store = new Vuex.Store({
     state:initialState,
     getters: {
         items: (state) => {
             if(state.recentMode){
                 return state.recent;
             }
             if(!state.data.channel) return [];
             return state.data.channel.item;
         }

     },
     mutations: {
         clearCompareData(state){
             state.comparedata.splice(0,state.comparedata.length);
         },
         addCompareData(state, data){
             state.comparedata.push(data);
         },
         setCompareData(state, data){
             data.data.forEach(o => state.comparedata[state.comparedata.length].data.push(o));
         },
         setMapData(state , data){
             state.mapdata = data.data
         },
         setNearData(state , data){
             state.neardata = data.data
         },
         recentMode(state){
             state.recentMode = !state.recentMode;
         },

         setData(state , data){
             state.data = data.data
         },
         addData(state , data){
             data.data.channel.item.forEach(function(item){
                 state.data.channel.item.push(item);
             });

         },
         addRecent(state , data){
             if(!state.recentId.includes(data.identifier)) {
                 state.recentId.push(data.identifier);
                 state.recent.push(data);
             }
         },
     },
     actions:{
         async fetch(ctx, param){
             const { data } = await ItemsRepository.getResource(param)
             
             if(param.idx === 1){
                 ctx.commit('setData', { data: data })
             }else{
                 ctx.commit('addData', { data: data })
             }
         },
         async mapfetch(ctx, param){
             const { data } = await ItemsRepository.getPointResource(param)
             
             ctx.commit('setMapData', { data: data })
         },
         async nearfetch(ctx, param){
             const { data } = await ItemsRepository.getResource(param)
             ctx.commit('setNearData', { data: data })
         },
         addRecent(ctx, param){
             ctx.commit('addRecent', param);
         },
         recentMode(ctx){
             ctx.commit('recentMode');
         },
         clearCompareData(ctx){
             ctx.commit('clearCompareData');
         },
         async addCompareData(ctx, _data){
             const { data } = await ItemsRepository.getResource(_data.param)
             _data.count = data.channel.totalResults
             _data.items = data.channel.item
             ctx.commit('addCompareData', _data)
         },

     },
     plugins: [createPersistedState({storage: window.sessionStorage})] 
 });
 
 const routes = [
     {path: '/', component: Top},
     {path: '/result', component: Result,
      children: [
          { path:'tile', component: ResultTile},
          { path:'map', component: ResultMap},
          { path:'compare', component: ResultCompare},
          { path:'', component: ResultLine},
      ]
     },
     {name:'detail', path: '/uuid/:uuid', component: Detail}
 ]
 const router = new VueRouter({
     mode: 'history',
     base: process.env.BASE_URL,
     routes})
 
 export default {
     store,
     name: 'app',
     router: router
 }
</script>

<style>
 #app {
 }

 * {
     margin: 0;
     padding: 0;
 }

 /*@font-face {
    font-family: "Noto Sans Japanese";
    font-style: normal;
    src: url("fonFile.woff2") format("woff2");
    font-display: swap;
    }*/

 html,
 body {
     margin: 0;
     padding: 0;
     /*color: #006;*/
     color: #332C59;
     font-family: "Noto Sans Japanese", sans-serif;
     font-weight: 400;
     font-size: 15px;
     text-align: left;
     /*background: url(./assets/search_bg.png) repeat-x left 90px;*/
 }

 img {
     border: none;
     vertical-align: middle;
     /*-webkit-backface-visibility: hidden;*/
 }


 div, h1, h2, h3, h4, p, ul, li,
 th, td, form, input, textarea {
     margin: 0;
     padding: 0;
 }

 ul li {
     list-style: none;
     text-decoration: none;
 }

 /*---------------------------------
    Text Link
    ----------------------------------*/

 a:link {
     color: #332C59;
     text-decoration: none;
 }

 a:visited {
     color: #332C59;
     text-decoration: none;
 }

 a:hover,
 footer a:hover {
     opacity: 0.7;
 }

 /*.hover {
    opacity: 0.7;
    }*/

 .fixed {
     overflow: auto;
     height: 100%;
 }



 /*---------------------------------
    Layout
    ----------------------------------*/

 .container {
     /*min-width: 980px;*/
     max-width: 100%;
     margin: 0;
     padding: 0;
     line-height: 1.7;
 }

 header {
     margin: 0 auto;
     padding: 5px 0 0 0;
     width: 85%;
     height: 90px;
     overflow: hidden;  /*float対策 */
 }

 nav {
     width: 100%;
     /*height: 34px;*/
     margin: 0 ;
     padding: 0;
     /*min-width: 1000px;*/
     clear: both;
     /*background:#eee url(./assets/bg.png) repeat left top;*/
     background-color: #f5f5f5;
 }

 .wrapper {
     clear: both;
     width: 100%;
     overflow: hidden;
     /*min-width: 1000px;
        background: url(./assets/bg.png) repeat left top;*/
 }

 .contents {
     margin: 1px auto 0 auto;
     padding: 25px 0 12px 0;
     width: 85%;
     /*width: 980px;*/
     overflow: hidden;
 }

 .side {
     float: left;
     margin: 0;
     padding: 15px;
     width: 220px;
     /*box-shadow: 0 1px 2px 2px rgba(0,0,0,0.05);
        background: url(./assets/side_bg.png) repeat left top;*/
     font-size: 95%;
     border: 1px solid #332C59;
     box-sizing: border-box;
 }

 article {
     /*margin: 0;
        padding: 5px 0 0 0;
        width: 800px;*/

     overflow: hidden;
     /*background-color: #ccc;*/
 }

 footer {
     
 }


 /*---------------------------------
    Header
    ----------------------------------*/


 header h1 {
     float: left;
     margin-top: 5px;
 }

 header h1 a img{
     width: 70px;
     height: auto;
 }

 header h2 {
     float: left;
     line-height: 1.1;
     margin: 0 0 0 10px;
     font-size: 138%;
 }

 header h2 .site-name{
     margin-left: 15px;
 }

 header h2 .site-copy{
     font-size: 55% ;
     font-weight: normal;
 }

 .head-r {
     float: right;
     margin-top: 18px;
 }


 /*---------------------------------
    search-box
    ----------------------------------*/

 .search-box {
     margin: 0 auto;
     width: 85%;
     padding: 15px 0;
     box-sizing: border-box;
     overflow: hidden;
     position: relative;
 }

 .search-input {
     box-sizing: border-box;
     padding-right: 435px;
     width: 100%;
 }

 .search-input input {
     font-size: 16px;
     padding: 0 10px;
     line-height: 40px;
     width: 100%;
     height: 40px;
     border: 1px solid #332C59;
     color: #332C59;
     box-sizing: border-box;
     -webkit-appearance: none;
     border-radius: 0;
 }

 .search-btn-box {
     margin: 0;
     width: 435px;
     position: absolute;
     right: 0;
     top: 15px;
 }
 .search-btn-box ul li {
     padding-left: 15px;
     border-left: 1px solid #332C59;
 }
 .search-btn-box a {
     width: 130px;
     height: 40px;
     display: block;
     margin-left: 15px;
     float: left;
     padding: 0;
     text-align: center;
     line-height: 40px;
     background-color: #332C59;
     font-size: 105%;
     color: #fff;
     box-sizing: border-box;
     /*letter-spacing: 0.1em;*/
 }

 .search-btn-box a.btn-rireki {
     position: relative;
 }
 .search-btn-box a span.ex{
     position: absolute;
     width: 10px;
     height: 10px;
     background-color: red;
     display: block;
     left: 0;
     bottom: 0;
 }

 .search-btn-box a img{
     vertical-align: middle;
     margin-right:5px;
 }

 .btn-cond {
     display: none;
 }


 .btn-cond a{
     width: 40px;
     height: 40px;
     display: block;
     padding: 0;
     text-align: center;
     line-height: 40px;
     background-color: #332C59;
     box-sizing: border-box;
     float: left;
 }

 /*.btn-comp {
    background:url(./assets/btn_comp_s.png) no-repeat left top;
    }*/

 .search-box .det-btn-box {
     float: right;
 }


 /*---------------------------------
    side
    ----------------------------------*/
 /*.side-top {
    margin: 10px 0 0 0;
    background: url(./assets/navi_top_bg.png) no-repeat left top;
    display: block;
    width: 164px;
    height: 10px;
    }

    .side-menu {
    margin: 0;
    padding: 0 0 10px 15px;
    background: url(./assets/navi_bg.png) repeat-y left top;
    width: 149px;
    font-size: 95%;
    }


    .side-bottom {
    margin: 0 0 10px 0;
    background: url(./assets/navi_bottom_bg.png) no-repeat left top;
    display: block;
    width: 164px;
    height: 10px;
    }
  */

 .side ul {
     margin-bottom: 20px;}
 
 .side ul {
     padding-left:18px;
     text-indent:-17px;
 }

 ul.mgnb-none {
     margin-bottom: 0;
 }

 .btn-acc {
     cursor: pointer;
     background: url(./assets/ar_u.png) no-repeat right center;
 }
 .ar-d {
     background: url(./assets/ar_d.png) no-repeat right center;
 }

 .accordion_head {
     cursor: pointer;
 }

 .btn-acc:hover,
 .accordion_head:hover {
     opacity: 0.7;
 }

 .side-title {
     font-weight: bold;
     font-size: 110%;
     border-bottom: 2px solid #332C59;
     color: #332C59;
     margin-bottom: 10px;
     display: none;
 }

 .side-close {
     float: right;
     cursor: pointer;
     margin-right: 15px;
     display: none;
 }

 /*---------------------------------
    main
    ----------------------------------*/

 h1 {
     margin: 0 4px 0 0;
     padding: 0;
     float: left;
 }

 h2 {
     margin: 0;
     padding: 16px 0 0 0;
     float: left;
 }

 h3 {
     margin: 0 0 10px 0;
     width: 100%;
     font-size: 120%;
     font-weight: normal;
     border-bottom: 1px dotted #ccc;
 }

 h4 {
     font-size: 105%;
 }

 h5 {
     font-size: 12px;
     margin:0;
     padding:0;
 }

 article p.text-box {
     margin: 10px;
 }

 div.btn-box2 {
     margin: 7px auto 0 auto;
     padding: 5px;
     width: 328px;
     overflow: hidden;
     text-align: center;
 }

 div.btn-box1 {
     margin: 7px auto 0 auto;
     padding: 5px;
     width: 164px;
     overflow: hidden;
     text-align: center;
 }



 div.btn-box1 a:hover,
 div.btn-box2 a:hover {
     background-position: left bottom;
 }

 .clear {
     clear: both;
 }


 div.text-center {
     width: 100%;
     margin: 10px 0 0 0;
     text-align: center;
 }

 div.text-center span{
     font-size: 170%;
     margin: 0 10px;
 }



 .btn-more-box {
     clear: both;
     width: 100%;
     padding: 5px 0;
     margin: 20px 0;
     background-color: #332C59;
     color: #fff;
     text-align: center;
     font-size: 105%;
     display:block;
     cursor: pointer;
 }

 .btn-more-box img {
     margin-right: 10px;
 }

 .btn-more-box:hover {
     /*background-color: #bbb;*/
 }

 .required {
     color: #C69;
 }


 /* ==========================================================================
    Footer
    ========================================================================== */

 footer {
     margin: 50px 0 0;
     padding: 0;
     /*overflow: hidden;*/
     width: 100%;
     /*background:#eee url(./assets/bg.png) repeat left top;*/
     background-color: #f5f5f5;
 }

 .foot-box {
     width: 85%;
     margin: 0 auto;
     padding: 30px 0;
     position: relative;
 }

 .finfo {
     padding: 0;
 }

 .flogo-box {
     margin-top: 10px;
     overflow: hidden;
 }

 .flogo-box ul li {
     /*width: 160px;*/
     height: 52px;
     float: left;
     margin-right: 20px;
 }

 .flogo-box ul li a img{
     vertical-align: middle;
 }

 .fname {
     font-weight: bold;
 }

 .fname span{
     margin-right: 10px;
 }

 .img-responsive {
     width: auto;
     height: 100%;
 }

 .foot-cbox {
     background-color: #332C59;
     width: 100%;
     margin: 0;
 }

 .copy-box {
     width: 85%;
     margin: 0 auto;
     padding: 8px 0;
     font-size: 80%;
     color: #fff;
     overflow: hidden;
 }

 .copyright {
     float: left;
     letter-spacing: 0.1em;
     font-weight: bold;
 }

 .term {
     float: right;
     font-weight: bold;
 }

 .copy-box a {
     vertical-align: bottom;
     color: #fff;
 }

 .toh {
     position: absolute;
     right: -17px;
     bottom: 17px;
     width: 110px;
 }

 .copyright a,
 .toh a {
     display: inline-block;
 }



 #page-top {
     width: 40px;
     height: 40px;
     position: fixed;
     right: 30px;
     bottom: 30px;
     z-index: 1000;
 } 
 
 footer #page-top a:hover {
     opacity: 1;
 }
 
 @media screen and (max-width:740px) {

     /*common*/

     header {
         height: 55px;
     }

     header h1 {
         margin-top: 3px;
         padding: 0;
         height: 45px;
         width: auto;
         line-height: 1;
     }

     header h1 a img{
         height: 45px;
         width: auto;
     }

     header h2 {
         margin: 6px 0 0 5px;
         padding: 0;
         font-size: 102%;
     }

     header h2 .site-name{
         margin-top: 2px;
         margin-left: 0;
         display: block;
     }

     header h2 .site-copy{
         display: none;
     }

     .contents {
         padding-top: 12px;
     } 


     .foot-box {
         width: 90%;
         padding: 8px 90px 8px 0;
         box-sizing: border-box;
         line-height: 1.5;
         height: 80px;
     }

     .flogo-box {
         margin-top: 5px;
     }

     .flogo-box ul li {
         width: 80px;
         margin-right: 10px;
     }

     .fname {
         font-weight: bold;
         font-size: 75% ;
     }

     .fname span{
         display: block;
     }

     .img-responsive {
         width: 100%;
         height: auto;
     }

     .foot-cbox {
         background-color: #332C59;
         width: 100%;
         margin: 0;
     }

     .copy-box {
         width: 90%;
     }

     .copyright {
         padding: 5px 50px 5px 0;
         font-size: 85%;
         box-sizing: border-box;
         line-height: 1.5;
         float: none;
         width: 100%;
     }

     .copyright span{
         display: block;
     }

     .copyright a {
         vertical-align: bottom;
     }

     .term {
         float: none;
         font-size: 90%;
         display: block;
     }

     .toh {
         position: absolute;
         right: 0;
         bottom: 6px;
         width: 65px;
     }

     .toh a img {
         width: 100% ;
         height: auto;
     }


     #page-top {
         width: 40px;
         height: 40px;
         right: 0;
         bottom: 0;
     } 

     #page-top img{
         width: 100%;
         height: 100%;
     }


 }


 @media screen and (max-width:480px) {
     html,
     body {
         overflow-x: hidden !important;
     }
     a:hover img {
         opacity: 1;
     }
     .sp {
         display: block;
     }
     .sp-hidden {
         display: block;
     }

     .hmenu,
     .is-animation .hmenu {
         margin-right: 0;
     }

     .sp-logo {
         display: block;
     }

     .sp-logo img{
         display: block;
         float: left;
     }


     .logo01,
     .is-animation .logo01 {
         width: 240px;
         height: 55px;
     }


     .hmenu .menu {
         margin-top: 15px;
         transition: .2s;
     }


     .search-text{
         width: 60%;
         font-size: 18px;
     }

     .search-submit{
         width: 40%;
         font-size: 18px;
     }

     .btn-l {
         padding: 15px 30px;
         font-size: 120%;
     } 

     .contents-full {
         padding-top: 10px;
     }

     .bm-box {
         padding: 15px 10px;
         line-height: 1.7;
     }

     .bm-box ul li{
         background-position: 3px left;
         padding-left: 20px;
     }


 }

</style>
